import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { transientOptions } from "shared/lib/styles";

import { SCMPYouTubeVideoFooter } from "./scmp-youtube-video-footer";

type StyledSCMPYouTubeVideoFooterProps = {
  $orientation: "landscape" | "portrait";
};

export const StyledSCMPYouTubeVideoFooter = styled(SCMPYouTubeVideoFooter, {
  ...transientOptions,
})<StyledSCMPYouTubeVideoFooterProps>`
  ${props => {
    if (props.$orientation === "portrait") {
      return css`
        &&&& {
          inline-size: var(--portrait-inline-size);
          margin-inline: auto;
        }
      `;
    }
    switch (props.variant) {
      case "default":
        return css`
          display: flex;
        `;
    }
  }}
`;

export const SCMPYoutubeVideoContainer = styled.div`
  inline-size: 100%;
  block-size: auto;

  aspect-ratio: 16 / 9;
`;
